import { Link } from '@loomhq/lens';
import React from 'react';

import { LOOM_URI } from 'constants/routes';

import { useLogTagClickedMutation } from '../../../tags/tag-events';

import styles from './styles.module.less';

export default function TagLink({ tag, ...linkProps }) {
  const logTagClicked = useLogTagClickedMutation();

  return (
    <Link
      variant="neutral"
      onClick={() => {
        logTagClicked({
          variables: {
            tag,
            context: 'SharePage',
          },
        });
      }}
      href={`${LOOM_URI}/tag/${tag}`}
      className={styles.tagLink}
      {...linkProps}
    >
      {`#${tag}`}
    </Link>
  );
}
